export default {
  default: 'Unknown error occur',
  noFileProvided: 'No file provided',
  confirmationParamsWrong: 'Confirmation params are wrong. Please, check the URL!'
}


// WEBPACK FOOTER //
// ./src/utils/errors.js